import React from 'react';

const AsyncRadioAds = React.lazy(() => import('./ListContainer'));

export const RadioAdsPage = () => {
  return <AsyncRadioAds />;
};
